import React from 'react';

export class AsyncCss extends React.Component {
  componentDidMount () {
    // Intject the tag
    var resource = document.createElement('link'); 
    resource.setAttribute("rel", "stylesheet");
    resource.setAttribute("href", this.props.href);
    resource.setAttribute("type","text/css");      
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(resource);
  }

  render () {
    return <React.Fragment />;
  }
}
